/**
 * `GD-14` — khối gập "Chi tiết kỹ thuật", DÙNG CHUNG (vòng 3 tách khỏi `CabinetDetail.tsx` để
 * `CaiDatThietBi.tsx` và thẻ "Cần chú ý" cũng đưa tên trường / số hex vào đúng một chỗ).
 *
 * L-CHỮ-NGƯỜI-DÙNG: mặt trước chỉ có câu người đọc; mã, tên trường, số hex nằm ở đây.
 */
import type { ReactNode } from 'react';
import { useAuth } from '../lib/auth';

/** Quản trị hệ thống (`SUPER_ADMIN`) — người DUY NHẤT thấy "Chi tiết kỹ thuật" và mã thiết bị đủ. */
export function useLaQuanTri(): boolean {
  return useAuth().user?.role === 'SUPER_ADMIN';
}

/**
 * Khối gập "Chi tiết kỹ thuật". ⛔ Không phải "ẩn vì quyền": đây là dữ liệu máy, không phải một
 *   tính năng — tài khoản khác không thấy cả tiêu đề của nó (L-CHỮ-NGƯỜI-DÙNG).
 */
export function ChiTietKyThuat({ children }: { children: ReactNode }) {
  if (!useLaQuanTri()) return null;
  return (
    <details className="mt-2 rounded-lg border border-vien px-2 py-1" data-chi-tiet-ky-thuat>
      <summary className="cursor-pointer select-none text-xs font-medium text-chu-2">Chi tiết kỹ thuật</summary>
      <div className="thin-scroll mt-1 max-h-60 overflow-auto text-chu-2">{children}</div>
    </details>
  );
}
